import { GETCUSTOMERDETAILS } from "../utils/api"
import axios from "../utils/axios"

export const getAllCustomer=async(payaload,callback)=>{
    await axios.post( GETCUSTOMERDETAILS,payaload).then((res)=>{
        callback(res)

    }).catch((err)=>console.log("err ",err))
}